import store from '@/store';
const SpinModule = () => import(/* webpackChunkName: "spin-module" */ './views/Module.vue');
const SpinWheelHistory = () => import(/* webpackChunkName: "SpinWheelHistory" */ './views/SpinWheelHistory.vue');

const SpinRoutes = {
    path: '/',
    component: SpinModule,
    children: [
        {
            path: "/spin-wheel-history",
            name: "SpinWheelHistory",
            component: SpinWheelHistory,
            beforeEnter: () => {
                const user = store.getters.stateUser;
                if (!user) return
                if (user?.isDemo) {
                    return { name: 'PageNotFound' }
                }
            }
        },
    ],
}

export default SpinRoutes;